import { ModuleDefinition } from '@/cmsBackend/transformers/page/commonPage';
import { getModuleComponent } from '@/common/modules/getModuleComponent';

/**
 * Common Module Component that correctly renders React Component based on CMS module type
 */
export const Module = ({ type, value, isFirstModule }: ModuleDefinition) => {
  const ModuleComponent = getModuleComponent(type);

  // Return empty fragment if no React Component mapped to provided CMS module type
  if (!ModuleComponent) {
    return <></>;
  }

  return <ModuleComponent {...value} {...(isFirstModule && { isFirstModule })} />;
};
